module.exports = __webpack_public_path__ + "static/media/lower.d96a836b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lower.svg
// module id = 209
// module chunks = 0